<script>
    import { SendRequest } from "./APIService";
    import { showModal } from "./Modal";
    import moment from "moment";

    let filtredClans = {};
    let clanData = {};

    let keys = [];
    let values = [];

    $: {
        keys = [];
        values = [];
        for (const [key, value] of Object.entries(clanData)) {
            keys = [...keys, key];
            values = [...values, value];
            console.log(`${key}: ${value}`);
        }
    }

    let totalDonations = 200;
    let totalBingos = 20;

    function FilterClans() {
        SendRequest(
            "GetClansWithHighDonations",
            "GET",
            "totalDonations=" + totalDonations + "&totalBingos=" + totalBingos,
            (response) => {
                console.log("Get Clans With High Donations Called");
                filtredClans = response;
            },
            (error) => {
                showModal("Error", "Bad Request", "OK");
                filtredClans = {};
            },
        );
    }

    function SearchClan(clanId) {
        SendRequest(
            "GetClanAndMembersData",
            "POST",
            "clanId=" + clanId,
            (response) => {
                console.log("GetClanAndMembersData Called");
                delete response.activeItemRequests;
                clanData = response;
            },
            (error) => {
                showModal("Error", "Clan not found", "OK");
                clanData = {};
            },
        );
    }
</script>

<br />
<br />
<br />

<div class="container">
    <div class="tab-content" id="myTabContent">
        <div
            class="tab-pane fade show active"
            id="search"
            role="tabpanel"
            aria-labelledby="search-tab"
        >
            <hr />
            <!-- Search clans -->
            <div class="row justify-content-md-center">
                <div class="card col-md-8">
                    <h5 class="card-header" style="text-align: center;">
                        <h3>Filter Clans</h3>
                    </h5>

                    <div class="card-body">
                        <div class="mb-3 row">
                            <label class="form-label"
                                >Total Donations Higher Than</label
                            >
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Total Donations"
                                bind:value={totalDonations}
                            />
                        </div>
                        <div class="mb-3 row">
                            <label class="form-label"
                                >Total Bingos Less Than</label
                            >
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Total Bingos"
                                bind:value={totalBingos}
                            />
                        </div>
                        <div class="mb-3 row">
                            <button
                                class="btn btn-danger"
                                type="button"
                                on:click={FilterClans}>Search</button
                            >
                        </div>
                    </div>
                </div>
            </div>

            {#if filtredClans.length > 0}
                <hr />
                <div class="row justify-content-md-center">
                    <div class="card col-md-8">
                        <div class="card-header" style="text-align: center;">
                            <h3>Filtred Clans</h3>
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Clan Id</th>
                                        <th scope="col">Total Bingos</th>
                                        <th scope="col">Total Donations</th>
                                    </tr>
                                </thead>
                                {#each filtredClans as prop, index}
                                    <tbody>
                                        <tr>
                                            <td>
                                                <a
                                                    class="text-info"
                                                    on:click={SearchClan(
                                                        prop.clanId,
                                                    )}
                                                >
                                                    {prop.clanId}
                                                </a>
                                            </td>
                                            <td>
                                                {prop.totalBingos}
                                            </td>
                                            <td>
                                                {prop.totalDonations}
                                            </td>
                                        </tr>
                                    </tbody>
                                {/each}
                            </table>
                        </div>
                    </div>
                </div>
            {/if}

            {#if keys.length > 0}
                <br />
                <br />
                <div class="row justify-content-md-center">
                    <div class="card col-md-8">
                        <div class="card-header" style="text-align: center;">
                            <h3>Clan Data</h3>
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered table-hover">
                                <tbody>
                                    {#each keys as prop, index}
                                        <tr>
                                            {#if prop == "clanTeamMembers"}
                                                <td>Clan Members</td>
                                                <td>
                                                    <!-- create a new table here -->
                                                    <table
                                                        class="table table-bordered table-hover"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th scope="col"
                                                                    >userId</th
                                                                >
                                                                <th scope="col"
                                                                    >userLevel</th
                                                                >
                                                                <!-- <th scope="col"
                                                                    >positionInClan</th
                                                                >
                                                                <th scope="col"
                                                                    >joinedAt</th
                                                                > -->
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {#each values[index] as prop2, index2}
                                                                <tr>
                                                                    <td
                                                                        >{prop2.userId}</td
                                                                    >
                                                                    <td
                                                                        >{prop2.userLevel}</td
                                                                    >
                                                                    <!-- {#if prop2.positionInClan == 0}
                                                                        <td
                                                                            >Owner</td
                                                                        >
                                                                    {:else if prop2.positionInClan == 1}
                                                                        <td
                                                                            >Admin</td
                                                                        >
                                                                    {:else}
                                                                        <td
                                                                            >Normal</td
                                                                        > -->
                                                                    <!-- {/if} -->
                                                                    <!-- <td
                                                                        >{moment(
                                                                            new Date(
                                                                                prop2.joinedAt,
                                                                            ),
                                                                        ).from(
                                                                            new Date(),
                                                                        )}</td
                                                                    > -->
                                                                </tr>
                                                            {/each}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            {:else if prop == "weeklyStats" && values[index]}
                                                <td>Weekly Stats</td>
                                                <td>
                                                    <!-- create a new table here -->
                                                    <table
                                                        class="table table-bordered table-hover"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th scope="col"
                                                                    >UserId</th
                                                                >
                                                                <th scope="col"
                                                                    >Stats</th
                                                                >
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {#each Object.keys(values[index]) as prop2, index2}
                                                                <tr>
                                                                    <td
                                                                        >{prop2}</td
                                                                    >
                                                                    <td
                                                                        >{JSON.stringify(
                                                                            Object.values(
                                                                                values[
                                                                                    index
                                                                                ],
                                                                            )[
                                                                                index2
                                                                            ],
                                                                        )}</td
                                                                    >
                                                                </tr>
                                                            {/each}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            {:else if prop == "clanName" && values[index]}
                                                <td>{prop}</td>
                                                <td
                                                    >{JSON.stringify(
                                                        values[index],
                                                    )}</td
                                                >
                                            {:else if prop == "totalStats" && values[index]}
                                                <td>{prop}</td>
                                                <td
                                                    >{JSON.stringify(
                                                        values[index],
                                                    )}</td
                                                >
                                            {:else if prop == "totalScore" && values[index]}
                                                <td>{prop}</td>
                                                <td
                                                    >{JSON.stringify(
                                                        values[index],
                                                    )}</td
                                                >
                                            {:else if prop == "clanId" && values[index]}
                                                <td>{prop}</td>
                                                <td
                                                    >{JSON.stringify(
                                                        values[index],
                                                    )}</td
                                                >
                                            {/if}
                                        </tr>
                                    {/each}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
    .nav-item :not(.active) {
        color: black;
    }

    .nav-item .active {
        color: white;
    }
</style>
